import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDeleteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#delete-icon_svg__a)">
      <path
        fill="#263E6A"
        d="M7.615 20q-.67 0-1.143-.472A1.56 1.56 0 0 1 6 18.385V6H5V5h4v-.77h6V5h4v1h-1v12.385q0 .69-.462 1.152a1.57 1.57 0 0 1-1.153.463zM17 6H7v12.385q0 .269.173.442a.6.6 0 0 0 .442.173h8.77a.59.59 0 0 0 .423-.192.59.59 0 0 0 .192-.423zM9.808 17h1V8h-1zm3.384 0h1V8h-1z"
      />
    </g>
    <defs>
      <clipPath id="delete-icon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDeleteIcon;
